import * as Yup from "yup";

export const validationSchema = Yup.object({
  isHidden: Yup.boolean().required("El campo es requerido"),
  idcarrier: Yup.string().required("El carrier es requerido"),
  name: Yup.string().required("El nombre es requerido"),
  isOKFileToSave: Yup.boolean().required("Es necesario pasar del paso 3"),
  uid_partner: Yup.string(),
  preprocess: Yup.boolean().required("El campo es requerido"),
});
